<template>
  <div>
    <bread-crumb></bread-crumb>
    <div class="content-manage">
      <div class="content-manage-header">
        <el-select
          v-model="baikeType"
          placeholder="请选择百科类型"
          size="mini"
          class="content-manage-header-type"
          @change="changeBaikeType"
        >
          <el-option
            v-for="(item, index) in contentBaikeType"
            :key="index"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>

        <el-select
          v-model="auditStatus"
          placeholder="请选择审核状态"
          size="mini"
          class="content-manage-header-status"
          @change="changeStatus"
        >
          <el-option
            v-for="item in auditStatusList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
            v-if="(contentType == 8 && item.value < 5) || contentType != 8"
          >
          </el-option>
        </el-select>
        <el-select
          v-model="contentStatus"
          placeholder="请选择文章状态"
          size="mini"
          class="content-manage-header-status"
          @change="changeContentStatus"
        >
          <el-option
            v-for="item in contentStatusList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
            v-if="(contentType == 8 && item.value < 5) || contentType != 8"
          >
          </el-option>
        </el-select>
        <el-button
          size="mini"
          class="content-manage-header-button"
          @click="resetSelectVal"
          >重置</el-button
        >
      </div>
      <div class="content-manage-list">
        <div class="content-manage-list-table">
          <el-table :data="tableData" style="width: 100%">
            <el-table-column prop="contentId" label="百科ID"> </el-table-column>
            <el-table-column prop="contentName" label="百科标题">
            </el-table-column>
            <el-table-column prop="contentType" label="百科类型">
              <template slot-scope="scope">
                <p>{{ contentTypes(scope.row.contentType) }}</p>
              </template>
            </el-table-column>
            <el-table-column prop="contentAuditStatus" label="审核状态">
              <template slot-scope="scope">
                <el-tooltip
                  effect="dark"
                  :content="tooltip_reject_msg"
                  placement="top"
                  style="display: inline-block"
                  v-if="scope.row.auditInfo.auditStatus == 4"
                >
                  <p
                    @mouseenter="showTypeDetail(scope.row)"
                    v-html="getContentAuditStatus(scope.row)"
                  ></p>
                </el-tooltip>
                <p v-else>{{ getContentAuditStatus(scope.row) }}</p>
              </template>
            </el-table-column>
            <el-table-column prop="contentStatus" label="百科状态">
              <template slot-scope="scope">
                <el-tooltip
                  effect="dark"
                  :content="tooltip_contentStatus_msg"
                  placement="top"
                  style="display: inline-block"
                  v-if="scope.row.contentStatus == 2"
                >
                  <p
                    @mouseenter="showContentStatusDetail(scope.row)"
                    v-html="getContentStatus(scope.row)"
                  ></p>
                </el-tooltip>
                <p v-else>{{ getContentStatus(scope.row) }}</p>
              </template>
            </el-table-column>
            <el-table-column
              fixed="right"
              align="left"
              label="操作"
              width="200"
            >
              <template slot-scope="scope">
                <!-- {label:'全部状态',value:-1},
                {label:'草稿',value:1},
                {label:'待审核',value:2},
                {label:'已发布',value:3},
                {label:'驳回',value:4},
                {label:'已下线',value:5},
                {label:'冻结',value:6},
                {label:'下线待审核',value:7},
                {label:'已删除',value:8} -->
                <el-button
                  v-if="scope.row.contentType != 37"
                  @click="articlePreview(scope.row)"
                  type="text"
                  size="small"
                  >预览</el-button
                >

                <span
                  class="border"
                  v-if="
                    scope.row.contentType !== 37 &&
                    (scope.row.auditInfo.auditStatus === 1 ||
                      scope.row.auditInfo.auditStatus == 4 ||
                      scope.row.auditInfo.auditStatus == 3)
                  "
                ></span>
                <el-button
                  type="text"
                  size="small"
                  @click="articleAlter(scope.row)"
                  v-if="
                    scope.row.auditInfo.auditStatus == 1 ||
                    scope.row.auditInfo.auditStatus == 4 ||
                    scope.row.auditInfo.auditStatus == 3
                  "
                >
                  修改
                </el-button>

                <span
                  class="border"
                  v-if="scope.row.auditInfo.auditStatus === 2"
                ></span>
                <el-button
                  type="text"
                  size="small"
                  @click="cancelApplyArticleForPinBut(scope.row)"
                  v-if="scope.row.auditInfo.auditStatus === 2"
                  >撤销投稿
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="content-manage-list-page">
          <pagination
            @sizePageChange="paginationChangeProduct"
            :paginationDatas="paginationDataProduct"
          ></pagination>
        </div>
        <modal
          :isShow.sync="dialogPreVisible"
          :title="dialogTitles"
          :btnText="btnText"
          :isShowBtn="isShowBtn"
          :width="dialogWidth"
        >
          <div class="content">
            <p class="before-content-color title">
              <span class="before-icon"></span> 移动端链接
            </p>
            <div class="image">
              <div class="flexs middle-a dialog-btns middle-a">
                <el-input
                  class="dialog-input"
                  v-model="mUrl"
                  placeholder="请输入移动端链接"
                ></el-input>
                <el-button class="color" type="text" size="small"
                  ><a :href="mUrl" target="_blank">打开</a></el-button
                >
                <el-button type="text" size="small" @click="copyUrl(mUrl)"
                  >复制</el-button
                >
              </div>
              <p class="dislog-sub-title">
                *预览页面不可用于商业用途，链接有效时间5分钟，超时过期请重新打开预览弹窗！
              </p>
              <div class="qrCode">
                <img :src="qrCode" alt="二维码图片" />
              </div>
              <div class="img-des">扫描二维码手机查看</div>
            </div>
          </div>
        </modal>
        <!-- <p>原创是指自己写的或团队自制、独立完成的作品，并对该内容有合法版权。抄袭或剽窃他人作品，汇总再编辑的文章，营销推广的内容，非独家授权或代理的作品，都不算原创内容。</p>
        <p>作者对内容的真实性、准确性负责，拥有内容中展示照片的合法版权。产生的后果作者需全部自行承担。</p> -->
        <!-- <div slot="footer" class="dialog-footer btns">
          <el-button type="primary" @click="originalTips=false">我知道了</el-button>
        </div>
      </el-dialog> -->
        <!--  -->
        <modal
          :isShow.sync="offLinearticleDialog"
          title="下线"
          :btnText="DialogBtn"
          :isShowBtn="ShowBtn"
          :width="Width"
          @clickHandler="offLineclickHandler"
        >
          <!-- <el-form label-position="top" label-width="80px" :model="formLabelAlign">
          <el-form-item label="下线理由"> -->
          <div class="dialog-conter">
            <div class="dialog-header">下线理由</div>
            <el-input
              class="dialog-conter-conter"
              type="textarea"
              size="medium"
              placeholder="请输入下线理由"
              v-model="formLabelAlign.offLineValue"
              maxlength="120"
              show-word-limit
            >
            </el-input>
          </div>
          <!-- </el-form-item>
        </el-form> -->
        </modal>
        <!--  -->
        <modal
          :isShow.sync="repealarticleDialog"
          title="撤销投稿"
          :btnText="DialogBtn"
          :isShowBtn="ShowBtn"
          :width="Width"
          @clickHandler="repealclickHandler"
        >
          <div class="content-main">是否撤销投稿</div>
        </modal>
        <!--  -->
        <modal
          :isShow.sync="repealoffLinearticleDialog"
          title="撤销下线申请"
          :btnText="DialogBtn"
          :isShowBtn="ShowBtn"
          :width="Width"
          @clickHandler="repealoffLineclickHandler"
        >
          <div class="content-main">是否撤销下线申请</div>
        </modal>
      </div>
    </div>
  </div>
</template>
<script>
import pagination from "../../../../components/pagination";
import modal from "../../../../components/modal";
import {
  getPreviewInfoByIdForPin,
  deleteDraftForPin,
  getUserDraft,
  listArticleTypesByPin,
} from "@/api/user.js";
import { getContentPreviewInfo, getAuditReason } from "@/api/common.js";
import breadCrumb from "../../../../components/breadCrumb";
import {
  withdrawalContribution,
  changgeDiseaseSymptomsOnline,
} from "@/api/symptomaticDisease.js";
import QRCode from "qrcode";

const baseUrl = process.env.VUE_APP_BASEURL;
export default {
  components: {
    modal,
    breadCrumb,
    pagination,
  },
  name: "contentCreate",
  data() {
    return {
      imgHost: "//image.healthjd.com/da/",
      formLabelAlign: {
        offLineValue: "",
      },
      // 被驳回提示消息
      tooltip_reject_msg: "",
      // 已下线提示消息
      tooltip_contentStatus_msg: "",
      reasonType_reject: 1,
      reasonType_onLine: 2,
      deletearticleDialog: false,
      repealarticleDialog: false,
      repealoffLinearticleDialog: false,
      offLinearticleDialog: false,
      tableValue: "",
      mUrl: "",
      dialogVal: "接口返回内容",
      Width: "400px",
      articleDialog: false,
      dialogHeaderTitles: "",
      ShowBtn: [],
      DialogBtn: [],
      qrCode: "",
      inputVal: "",
      dialogTitles: "预览",
      btnText: [],
      dialogWidth: "722px",
      isShowBtn: [false, false],
      dialogPreVisible: false,
      previewDialog: false,
      auditStatusList: [
        { label: "全部审核状态", value: -1 },
        { label: "草稿", value: 1 },
        { label: "待审核", value: 2 },
        { label: "已发布", value: 3 },
        { label: "被驳回", value: 4 },
        { label: "已下线", value: 5 },
        // {label:'冻结',value:6},
        { label: "待下线审核", value: 7 },
        { label: "已删除", value: 8 },
      ],
      contentStatusList: [
        { label: "全部文章状态", value: -1 },
        { label: "已上线", value: 1 },
        { label: "已下线", value: 2 },
      ],
      contentBaikeType: [{ label: "全部百科类型", value: "", route: "" }],
      contentStatus: -1,
      auditStatus: -1,
      contentType: -1,
      baikeType: "",
      tableData: [],
      paginationDataProduct: {
        total: 0,
        currentPage: 1,
        pageSize: 10,
      },
      baseUrl,
    };
  },
  created() {
    if (this.$route.path == "/manageBK") {
      this.contentType = 8;
    }
    this.listArticleTypesByPin();
  },
  filters: {
    // contentTypes: function (data) {
    //   switch (data) {
    //     case 1:
    //       return '图文'
    //     case 2:
    //       return '搭配'
    //     case 3:
    //       return '京装'
    //     case 4:
    //       return '帮助'
    //     case 5:
    //       return '单空间'
    //     case 6:
    //       return '整层'
    //     case 7:
    //       return '视频'
    //     case 8:
    //       return '疾病百科'
    //     case 9:
    //       return '症状百科'
    //     case 10:
    //       return '文章子文章'
    //     case 13:
    //       return '药品百科'
    //     case 16:
    //       return '疫苗百科'
    //     case 17:
    //       return '保健百科'
    //     case 19:
    //       return '滋补百科'
    //      case 20:
    //       return '器械百科'
    //      case 21:
    //       return '中医疾病百科'
    //      case 22:
    //       return '消费医疗百科'
    //      case 23:
    //       return '宠物百科'
    //      case 24:
    //       return '检查指标百科'
    //     default:
    //       return '';
    //   }
    // }
  },
  methods: {
    contentTypes(value) {
      console.log(
        this.contentBaikeType.find((item) => item.value === value).label
      );
      return this.contentBaikeType.find((item) => item.value === value).label;
    },
    listArticleTypesByPin() {
      listArticleTypesByPin({
        tenantId: parseInt(this.$commonJs.getTenantId()),
      }).then((res) => {
        console.log(res);
        if (res) {
          this.contentBaikeType = [
            { label: "全部百科类型", value: "", route: "" },
            ...res
              ?.filter((type) => type?.url?.indexOf("commonwiki") > -1)
              .map((item) => ({
                label: item.name,
                value: item.contentType,
                route: item.route || "",
              })),
          ];
          this.pageArticlesByPin();
        }
      });
    },
    paginationChangeProduct(val) {
      this.paginationDataProduct = val;
      this.pageArticlesByPin();
    },
    copyUrl(content) {
      /**
       * 复制内容到粘贴板
       * content : 需要复制的内容
       * message : 复制完后的提示，不传则默认提示"复制成功"
       */
      const aux = document.createElement("input");
      aux.setAttribute("value", content);
      document.body.appendChild(aux);
      aux.select();
      document.execCommand("copy");
      document.body.removeChild(aux);
      this.$message.success("复制成功");
    },
    // 预览
    articlePreview(val) {
      this.dialogPreVisible = true;
      this.previewDialog = true;
      const route = this.contentBaikeType.find(
        (item) => item.value == val.contentType
      ).route;
      this.jumpUrl(val.contentType, `${route}/`, "preview/", val.contentId);
      return;
    },
    jumpUrl(type, url, urlPre, urlId) {
      let urlAddress = "//beta-api.m.jd.com";
      let previewUrl1 = "https://cont-yf.healthjd.com/wiki/"; // 疾病症状预发地址
      let diseaseOnline = "https://cont.healthjd.com/wiki/"; // 线上疾病
      let newUrl;
      if (this.baseUrl === urlAddress) {
        // 预发
        newUrl = previewUrl1 + url + urlPre + urlId;
      } else {
        newUrl = diseaseOnline + url + urlPre + urlId;
      }
      this.mUrl = `${newUrl}${type === "preview/" ? "-man" : ""}`;
      this.getQRCode(newUrl);
    },
    // 修改
    articleAlter(row) {
      console.log(row);
      const route = this.contentBaikeType.find(
        (item) => item.value == row.contentType
      ).route;
      this.$router.push({
        path: "/commonwiki",
        query: {
          id: row.contentId,
          articleType: row.contentType,
          type: row.contentType,
          route: "userDetails",
          croute: route,
          articleStatus: row.contentAuditStatus,
        },
      });
    },
    //生成二维码
    getQRCode(val) {
      var opts = {
        errorCorrectionLevel: "H",
        type: "image/jpeg",
        rendererOpts: {
          quality: 0.3,
        },
      };

      QRCode.toDataURL(val, opts, (err, url) => {
        if (err) throw err;
        this.qrCode = url;
        this.dialogPreVisible = true;
      });
    },
    // 查看驳回理由
    showTypeDetail(row) {
      this.tooltip_reject_msg = row.auditInfo.remark;
    },
    // 查看下线原因 --------------------------------下午
    showContentStatusDetail(row) {
      this.tooltip_contentStatus_msg = row.statusInfo.remark;
    },
    getContentAuditStatus(row) {
      var data = row.auditInfo.auditStatus;
      switch (data) {
        case 1:
          return "草稿";
        case 2:
          return "待审核";
        case 3:
          return "已发布";
        case 4:
          return '<div class="contentAuditStatus">被驳回<i class="iconfont icon-iconfontxiaogantanhao"></i></div>';
        case 5:
          return "已下线";
        case 6:
          return "冻结";
        case 7:
          return "待下线审核";
        case 8:
          return "已删除";
        default:
          return "";
      }
    },
    getContentStatus(row) {
      var data = row.contentStatus;
      switch (data) {
        case 1:
          return "已上线";
        case 2:
          return '<div class="contentStatus">已下线<i class="iconfont icon-iconfontxiaogantanhao"></i></div>';
        default:
          return "";
      }
    },
    // 选择百科类型
    changeBaikeType(val) {
      this.baikeType = val;
      this.paginationDataProduct = {
        total: 0,
        currentPage: 1,
        pageSize: 10,
      };
      this.pageArticlesByPin();
    },
    changeType(val) {
      this.contentType = val;
      // 改变文章类型条件，应该也清空状态审核
      this.auditStatus = -1;
      this.paginationDataProduct = {
        total: 0,
        currentPage: 1,
        pageSize: 10,
      };
      this.pageArticlesByPin();
    },
    changeStatus(val) {
      this.paginationDataProduct = {
        total: 0,
        currentPage: 1,
        pageSize: 10,
      };
      this.auditStatus = val;
      this.pageArticlesByPin();
    },
    changeContentStatus(val) {
      this.paginationDataProduct = {
        total: 0,
        currentPage: 1,
        pageSize: 10,
      };
      this.contentStatus = val;
      this.pageArticlesByPin();
    },
    resetDataKeyName(data) {
      for (var i = 0; i < data.length; i++) {
        var d = data[i];
        data[i] = {
          contentId: d.id,
          contentName: d.title,
          contentAuditStatus: d.articleStatus,
          contentType: d.articleType,
        };
      }
    },
    //获取用户的文章列表
    pageArticlesByPin() {
      let vm = this;
      getUserDraft({
        tenantId: parseInt(this.$commonJs.getTenantId()), // 租户ID
        searchKeyword: undefined, // 搜素关键字
        pinyinFirstLetter: undefined, // 拼音首字母 String false
        // contentType: this.baikeType, // 疾病类型 1：疾病百科 Integer false
        contentTypes: this.baikeType
          ? [this.baikeType]
          : this.contentBaikeType
              .filter((item) => item.value)
              .map((item) => item.value), // 所有百科类型
        contentId: undefined, //  内容基本信息id Long  false
        contentName: undefined, // 内容名称 String false
        aliasName: undefined, // 别名 String false
        englishName: undefined, // 英文名 String false
        departId: undefined, // 科室id Long false
        auditStatus: vm.auditStatus == -1 ? undefined : [vm.auditStatus], // 内容审核状态list1草稿、2待审核、3审核通过、4驳回 List<Integer> false
        contentStatus: vm.contentStatus == -1 ? [] : [vm.contentStatus], // 文章状态
        pageNo: vm.paginationDataProduct.currentPage, //  页码  Integer false 1
        pageSize: vm.paginationDataProduct.pageSize, //  分页条数  Integer false 10
      }).then((res) => {
        vm.tableData = res.data;
        vm.paginationDataProduct.total = res.totalCount;
        vm.paginationDataProduct.currentPage = res.pageNo;
        vm.paginationDataProduct.pageSize = res.pageSize;
      });
    },
    deleteclickHandler(val) {
      if (val === "one") {
        this.deletearticleDialog = false;
      } else if (val === "two") {
        this.deleteDraftForPin(this.tableValue);
        this.deletearticleDialog = false;
      }
    },
    deleteDraftForPin(val) {
      deleteDraftForPin({
        tenantId: this.$commonJs.getTenantId(),
        articleId: Number(val.contentId),
      })
        .then((res) => {
          this.$message.success("删除成功！");
          this.pageArticlesByPin();
        })
        .catch((err) => {
          this.$message.error("删除失败！");
        });
    },
    // 下线
    applyOfflineForPinBut(val) {
      this.formLabelAlign.offLineValue = "";
      (this.ShowBtn = [true, true]), (this.DialogBtn = ["取消", "确定"]);
      this.offLinearticleDialog = true;
      this.tableValue = val;
    },
    offLineclickHandler(val) {
      if (val === "one") {
        this.offLinearticleDialog = false;
      } else if (val === "two") {
        if (this.formLabelAlign.offLineValue === "") {
          return this.$message.error("请输入下线理由");
        }
        this.applyOfflineForPin(this.tableValue);
        this.offLinearticleDialog = false;
      }
    },
    applyOfflineForPin(val) {
      if (this.formLabelAlign.offLineValue) {
        changgeDiseaseSymptomsOnline({
          tenantId: this.$commonJs.getTenantId(),
          contentId: Number(val.contentId),
          contentStatus: 2,
          remark: this.formLabelAlign.offLineValue,
        })
          .then((res) => {
            this.pageArticlesByPin();
            this.$message.success("申请成功！");
          })
          .catch((err) => {
            this.$message.error("申请下线失败,请稍后再试");
          });
      } else {
        this.$message.error("请输入理由");
      }
    },
    //撤销申请下线
    cancelApplyOfflineForPinBut(val) {
      this.ShowBtn = [true, true];
      this.DialogBtn = ["取消", "确定"];
      this.repealoffLinearticleDialog = true;
      this.tableValue = val;
    },
    repealoffLineclickHandler(val) {
      if (val === "one") {
        this.repealoffLinearticleDialog = false;
      } else if (val === "two") {
        this.cancelApplyOfflineForPin(this.tableValue);
        this.repealoffLinearticleDialog = false;
      }
    },
    cancelApplyOfflineForPin(val) {
      withdrawalContribution({
        tenantId: this.$commonJs.getTenantId(),
        contentId: Number(val.contentId),
      })
        .then((res) => {
          if (res == "0000") {
            this.pageArticlesByPin();
            this.$message({
              message: "撤销申请下线成功",
              type: "success",
            });
          }
        })
        .catch((err) => {
          console.log(err);
          this.$message.error("撤销申请下线失败,请稍后再试");
        });
    },
    // 撤销投稿
    cancelApplyArticleForPinBut(val) {
      (this.ShowBtn = [true, true]), (this.DialogBtn = ["取消", "确定"]);
      this.tableValue = val;
      this.repealarticleDialog = true;
    },
    repealclickHandler(val) {
      if (val === "one") {
        this.repealarticleDialog = false;
      } else if (val === "two") {
        this.cancelApplyArticleForPin(this.tableValue);
        this.repealarticleDialog = false;
      }
    },
    // 撤销请求
    cancelApplyArticleForPin(val) {
      var func;
      var params;
      func = withdrawalContribution;
      params = {
        tenantId: this.$commonJs.getTenantId(),
        contentId: val.contentId,
      };
      func(params)
        .then((res) => {
          if (res) {
            this.pageArticlesByPin();
            this.$message({
              message: "撤销成功",
              type: "success",
            });
          }
        })
        .catch((err) => {
          this.$message.error(err && err.msg ? err.msg : "操作失败!");
          this.pageArticlesByPin();
        });
    },
    resetSelectVal() {
      this.contentType = -1;
      this.auditStatus = -1;
      this.contentStatus = -1;
      this.baikeType = "";
      this.paginationDataProduct.currentPage = 1;
      this.pageArticlesByPin();
    },
  },
};
</script>

<style scoped lang="scss">
.content {
  padding: 26px 25px 18px 26px;
}

.contentAuditStatus_BK {
  max-width: 318px !important;
  max-height: 100px !important;
  overflow: auto;
}

:deep(.contentAuditStatus) {
  display: inline-block;
  cursor: pointer;

  i {
    font-size: 14px;
    margin-left: 4px;
  }

  &:hover {
    color: #f62458;

    i {
      color: #f62458;
    }
  }
}

:deep(.contentStatus) {
  display: inline-block;
  cursor: pointer;

  i {
    font-size: 14px;
    margin-left: 4px;
  }

  &:hover {
    color: #f62458;

    i {
      color: #f62458;
    }
  }
}

.red {
  color: red;
}

.content-main {
  width: 100%;
  padding: 30px;
  font-size: 16px;
  text-align: center;
}

.content-manage {
  position: relative;
  padding: 22px 30px;
  width: 100%;
  background: #fff;

  .title {
    font-family: PingFangSC-Medium;
    font-size: 18px;
    color: rgba(38, 38, 38, 1);
  }

  .content-tabs {
    margin-top: 2px;

    .el-tabs__header {
      margin: 0 0 0px;
    }

    .el-tabs__item {
      padding: 0 18px;
      height: 52px;
      line-height: 52px;
      font-family: PingFangSC-Medium;
      font-size: 16px;
      color: rgba(38, 38, 38, 1);

      &.is-active {
        color: rgba(255, 110, 0, 1);
      }
    }

    .el-tabs__active-bar {
      background-color: #ff6e00;
    }

    .el-tabs__nav-wrap::after {
      content: "";
      background-color: transparent;
    }
  }

  .line {
    width: 100%;
    height: 1px;
    border: 1px solid rgba(227, 232, 235, 1);
    position: absolute;
    left: 0;
    top: 99px;
  }

  &-header {
    background-color: white;
    height: 60px;
    /*line-height: 60px;*/
    padding: 0 15px 0;
    border-radius: 3px;
    display: flex;
    align-items: center;

    &-type,
    &-status {
      width: 250px;
      height: 32px;
      float: left;

      :deep(el-input__inner el-input--mini) {
        height: 32px;
        line-height: 32px;
      }
    }

    &-status {
      margin-left: 15px;
    }

    &-button {
      width: 88px;
      height: 32px;
      background-color: #f8fafc;
      margin-left: auto;
      color: #9ca8b9;
    }
  }

  &-list {
    background-color: white;
    padding: 20px;
    margin-top: 15px;
    border-radius: 3px;

    &-table {
      border: solid 1px #e7eff8;
      border-bottom: none;

      :deep(.el-table thead th) {
        height: 54px;
        font-size: 14px;
        padding: 0px 10px 0px 10px;
        color: #5d6072;
        font-weight: bold;
        background: #fafbfd !important;
      }

      :deep(.el-table__body td),
      :deep(.el-table__body th) {
        height: 48px;
        padding: 0px 10px 0px 10px;
        color: #757575;
        font-size: 12px;
      }

      .border {
        margin: 0 5px 0;
        display: inline-block;
        height: 6px;
        width: 1px;
        /*background-color: black;*/
        border: 0.9px solid #266cee;
      }

      .delete {
        color: #f62458;
      }
    }

    &-page {
      margin-top: 20px;
      text-align: right;

      :deep(el-pagination__total) {
        color: #768597;
      }

      .page {
        margin-top: 20px;

        :deep(&.is-background .el-pager li:not(.disabled).active) {
          background: #266cee;
          font-size: 12px;
          color: #ffffff;
        }
      }
    }
  }
}

.dialog-input {
  width: 558px;
}

.color {
  color: #2c3443 !important;
  margin-left: 24px;
}

.dislog-sub-title {
  color: #8b8c9a;
  font-size: 12px;
  margin-top: 14px;
}

.image {
  margin-top: 20px;
}

.qrCode {
  width: 182px;
  height: 182px;
  margin: 60px auto;
  margin-bottom: 0px;
}

.img-des {
  margin: 0 auto;
  width: 182px;

  text-align: center;
}

.dialog-conter {
  padding: 34px;
  padding-top: 20px;
  padding-bottom: 20px;

  .dialog-header {
    font-size: 14px;
    font-weight: 600;
  }

  .dialog-conter-conter {
    min-height: 100px;
    margin-top: 20px;
  }
}

// 下拉框
.el-select-dropdown__item {
  font-size: 14px;
  font-weight: 100 !important;
}

.el-select-dropdown__item.selected,
.el-select-dropdown__item.hover {
  font-size: 14px;
  color: #266cee;
  font-weight: 100 !important;
}

:deep(.el-textarea__inner) {
  // height: 100%;
  min-height: 100px !important;
}
</style>
